import * as httpHelper from "../../utils/http-helper";
import { MD5, enc } from "crypto-js";

function confirmarDados(cpf: string, email: string, dataNascimento: string) {
  const headers = httpHelper.defaultHeaders();
  const params = { cpf, email, dataNascimento };

  return httpHelper.post(headers, params, `Usuario/CadastarSenha`);
}

function recastrarNovaSenhaSemConfirmacao(
  email: string,
  cpf: string,
  dataNascimento: string,
  novaSenha: string,
  confirmacaoNovaSenha: string
) {
  const headers = httpHelper.defaultHeaders();
  const params = {
    email,
    cpf,
    dataNascimento,
    novaSenha: MD5(novaSenha).toString(enc.Hex).toUpperCase(),
    confirmacaoNovaSenha: MD5(confirmacaoNovaSenha)
      .toString(enc.Hex)
      .toUpperCase(),
  };

  return httpHelper.post(
    headers,
    params,
    `Usuario/CadastarSenhaSemConfirmacao`
  );
}

function recadastrarNovaSenha(
  email: string,
  cpf: string,
  dataNascimento: string,
  novaSenha: string,
  confirmacaoNovaSenha: string,
  codigo: string
) {
  const headers = httpHelper.defaultHeaders();
  const params = {
    email,
    cpf,
    dataNascimento,
    novaSenha: MD5(novaSenha).toString(enc.Hex).toUpperCase(),
    confirmacaoNovaSenha: MD5(confirmacaoNovaSenha)
      .toString(enc.Hex)
      .toUpperCase(),
    codigo,
  };

  return httpHelper.post(headers, params, `Usuario/ConfirmarCadastroSenha`);
}

const recuperarSenhaService = {
  confirmarDados,
  recadastrarNovaSenha: recadastrarNovaSenha,
};

export default recuperarSenhaService;
